<div class="popup-card" (click)="$event.stopPropagation()">
  <!-- Header -->
  <div class="popup-header">
    <div class="popup-title">
      <i class="ti ti-bell"></i>
      <span>{{ 'notification.status_detail' | translate }}</span>
    </div>
    <div class="popup-header-right">
      <span class="live-badge" [class.connected]="isConnected">
        <span class="live-dot"></span>
        {{ isConnected ? ('common.live' | translate) : ('common.disconnected' | translate) }}
      </span>
      <button class="btn-icon" (click)="close()" [attr.aria-label]="'common.close' | translate">
        <i class="ti ti-x"></i>
      </button>
    </div>
  </div>

  <!-- Body -->
  <div class="popup-body" *ngIf="notification; else loading">
    <div class="field-row">
      <div class="field-card">
        <span class="field-label">{{ 'notification.headId' | translate }}</span>
        <span class="field-value mono">{{ notification.id }}</span>
      </div>
      <div class="field-card">
        <span class="field-label">{{ 'notification.notifyAt' | translate }}</span>
        <span class="field-value">{{ notification.dataOra }}</span>
      </div>
    </div>

    <div class="field-card ">
      <span class="field-label">{{ 'notification.status' | translate }}</span>
      <span class="stato-badge" [ngClass]="'stato-' + notification.stato">
        {{ getStatoLabel(notification.stato) }}
      </span>
    </div>

    <div class="field-card">
      <span class="field-label">{{ 'notification.message' | translate }}</span>
      <span class="field-value">{{ notification.messaggio }}</span>
    </div>

    <!-- Sezione touchpoint (solo in challenge-list) -->
    <div *ngIf="isDetailedView && notification.childList && notification.childList.length > 0" class="field-card">
      <span class="field-label">{{ 'notification.touchpoints' | translate }}</span>
      <div class="touchpoints-table">
        <table>
          <thead>
            <tr>
              <th>{{ 'notification.touchPointName' | translate }}</th>
              <th>{{ 'notification.status' | translate }}</th>
              <th>{{ 'notification.error' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let touchpoint of notification.childList">
              <td>{{ touchpoint.touchPointName }}</td>
              <td>
                <span class="stato-badge" [ngClass]="'stato-' + touchpoint.status">
                  {{ getStatoLabel(touchpoint.status) }}
                </span>
              </td>
              <td>{{ touchpoint.error || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Azioni -->
<div class="popup-actions"  *ngIf="notification; else loading">
  <button *ngIf="hasCommand(notification.stato, notificationCommand.RESEND)"
    class="btn-action" (click)="onRetry()">
    <i class="ti ti-refresh"></i> {{ 'common.retry' | translate }}
  </button>
  <button *ngIf="hasCommand(notification.stato, notificationCommand.DELETE)"
    class="btn-action btn-danger" (click)="onCancel()">
    <i class="ti ti-ban"></i> {{ 'common.cancel' | translate }}
  </button>
     <!-- ↓ aggiungi questo -->
    <button class="btn-action" (click)="onTriggerStartSchedule()">
        <i class="ti ti-player-play"></i> {{ 'notification.trigger_start_schedule' | translate }}
    </button>
</div>
  </div>

  <ng-template #loading>
    <div class="popup-loading">
      <i class="ti ti-loader-2"></i> {{ 'notification.connecting' | translate }}
    </div>
  </ng-template>
</div>


// WEBPACK FOOTER //
// ./src/app/views/notification/notification-popup-menu/notification-popup-menu.component.html